import React, { Component } from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import axios from 'axios';
import { kinetik_api_url } from '../utilities/const';
import {
    Header,
    SideNavbar
} from "~/app/index";
import WindowAlert from '../common/AlertComponent';
import SelectPayers from './SelectPayers';
import SelectBrokers from './SelectBrokers';
import CompanyProfile from './CompanyProfile';
import BillingPage from './BillingPage';
import UsersPage from './users/usersPage';
import UpdatePassword from './users/UpdatePassword';
import { companyProfileSettings } from '../actions/settings_companyProfile.action';
import toastr from "toastr";
import FontAwesome from 'react-fontawesome';


class SettingPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mas_username: "",
            mas_password: "",
            emedny_username: "",
            emedny_password: "",
            payers: [],
            selectedPayers: [],
            brokers: [
                { label: 'Broker One', value: 'Broker One' },
                { label: 'Broker Two', value: 'Broker Two' },
                { label: 'Broker Three', value: 'Broker Three' },
                { label: 'Caramel', value: 'caramel' },
                { label: 'Cookies and Cream', value: 'cookiescream' },
                { label: 'Peppermint', value: 'peppermint' },
            ],
            selectedBrokers: [],
            messageType: '',
            message: '',
            isInfoUpdated: false,
            userType: localStorage.getItem('userType'),
            activeTab: localStorage.getItem('userType') === "2" ? 3 : localStorage.getItem('userType') === "3" && 4
        };
    }

    selectPayers = (payers) => {
        this.setState({ selectedPayers: payers });
        this.props.companyProfileSettings({
            company_payers: payers
        });
    }

    selectBrokers = (broker) => {
        this.setState({ selectedBrokers: broker });
        this.props.companyProfileSettings({
            company_brokers: broker
        });
    }

    onChangeInputHandler = (e) => {
        this.props.companyProfileSettings({
            dispatch_info: e.target.value
        })
    }

    saveInformations = () => {
        let disPatchInfo = document.getElementById('dispatch_info').value;
        let URL = kinetik_api_url + '/update_boarding_info';
        axios.put(URL, {
            dispatch_info: disPatchInfo,
            company_payers: JSON.stringify(this.props.payersList),
            company_brokers: JSON.stringify(this.props.brokerList),
            user_id: this.props.user_id
        })
            .then((result) => {
                this.setState({
                    messageType: result.data.status,
                    message: result.data.message,
                    isInfoUpdated: true
                });
            })
            .catch((err) => {
                this.setState({
                    messageType: "error",
                    message: err.data.message,
                    isInfoUpdated: true
                });
            })
    }

    handleAlert = () => {
        this.setState({
            isInfoUpdated: false
        })
    }


    render() {

        if (localStorage.getItem('authToken') === null) {
            return (<Redirect to="/login" />);
        }
        return (
            <div>
                <Header />
                <SideNavbar />
                <div className="body-content">
                    <div className="page-title">Settings</div>
                    <div className="page-subtitle">Setting page</div>
                    <div className="status-content">


                        <Tabs
                            defaultActiveKey={this.state.activeTab ? this.state.activeTab : 1}
                            animation={false}
                            className="tabs_wrapper_boarding settings_page__tab_fx"
                            onSelect={this.onChangeTab}
                            activeKey={this.state.key}
                            id="update_setting_profile"
                        >
                            {this.state.userType === "1" && (
                                <Tab eventKey={1} title="Vendors" className="brding_cmn_tab_cls">

                                    <div className="row">
                                        <div className="col-md-4">
                                            <SelectPayers data={this.state.payers} onSelectPayers={this.selectPayers} selectedPayers={this.state.selectedPayers} />

                                        </div>
                                        <div className="col-md-4">
                                            <SelectBrokers data={this.state.brokers} onSelectBrokers={this.selectBrokers} selectedBrokers={this.state.selectedBrokers} />

                                        </div>
                                        <div className="col-md-4">
                                            <div className="brd_tab_cntnt vendor__ fx_dsptch">
                                                <h4 className="vendor_h_title">Dispatch</h4>
                                                <div className="brding_frm_ele vendor_dis fix_payers_margin">
                                                    {this.props.dispatch_info &&
                                                        <input onChange={this.onChangeInputHandler} defaultValue={this.props.dispatch_info} name="dispatch_info" id="dispatch_info" type="text" placeholder="Dispatch" />
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-2"></div>
                                        <div className="col-md-8 vendor_all_update_btn_area">
                                            <div className="brding_frm_ele update_pw_btn">
                                                <input onClick={this.saveInformations} type="submit" value="UPDATE MY PROFILE" />
                                            </div> <br />
                                        </div>
                                        <div className="col-md-2"></div>
                                    </div>
                                </Tab>
                            )}
                            {this.state.userType === "1" && (
                                <Tab eventKey={2} title="Company Profile" className="brding_cmn_tab_cls">
                                    <CompanyProfile />
                                </Tab>
                            )}
                            {(this.state.userType === "1" || this.state.userType === "2") && (
                                <Tab eventKey={3} title="Users" className="brding_cmn_tab_cls">
                                    <UsersPage />
                                </Tab>
                            )}
                            {(this.state.userType === "1" || "2" || "3") && (
                                <Tab eventKey={4} title="Password" className="brding_cmn_tab_cls">
                                    <UpdatePassword />
                                </Tab>
                            )}

                            {(this.state.userType === "1" || this.state.userType === "2") && (
                                <Tab eventKey={5} title="Billing" className="brding_cmn_tab_cls">
                                    <BillingPage />
                                </Tab>
                            )}
                            <Tab eventKey={6} title="API Connection" className="brding_cmn_tab_cls">
                                <br />
                                <div>MAS API Connection</div>
                                <br />
                                {(this.props.userData.provider_info && this.props.userData.provider_info.mas_connection === false) &&
                                    <div>
                                        <div className="brding_frm_ele">
                                            <span>Username</span>
                                            <input onChange={this.onChange_api_fields_handler} defaultValue={this.state.company_name} name="mas_username" type="text" placeholder="Username" />
                                        </div> <br />
                                        <div className="brding_frm_ele">
                                            <span>Password</span>
                                            <input onChange={this.onChange_api_fields_handler} defaultValue={this.state.company_address} name="mas_password" type="password" placeholder="Password" />
                                        </div>
                                        <button className="btn btn-primary submit-btn api-connection-btn" onClick={this.verify_handler_mas}>
                                            Verify
                                 </button>
                                    </div>
                                }
                                {(this.props.userData.provider_info && this.props.userData.provider_info.mas_connection === true) &&

                                    <div>Connection Status: <FontAwesome className="color-green" name="check-circle" /></div>
                                }
                                <br />
                                <br />
                                <div>EmedNY API Connection</div>
                                <br />

                                {(this.props.userData.provider_info && this.props.userData.provider_info.emedny_connection === false) &&
                                    <div>
                                        <div className="brding_frm_ele">
                                            <span>Username</span>
                                            <input onChange={this.onChange_api_fields_handler} defaultValue={this.state.company_name} name="emedny_username" type="text" placeholder="Username" />
                                        </div> <br />
                                        <div className="brding_frm_ele">
                                            <span>Password</span>
                                            <input onChange={this.onChange_api_fields_handler} defaultValue={this.state.company_address} name="emedny_password" type="password" placeholder="Password" />
                                        </div>
                                        <button className="btn btn-primary submit-btn api-connection-btn" onClick={this.verify_handler_emedny} >
                                            Verify
                                 </button>
                                    </div>
                                }
                                {(this.props.userData.provider_info && this.props.userData.provider_info.emedny_connection === true) &&

                                    <div >Connection Status: <FontAwesome className="color-green" name="check-circle" /></div>
                                }
                                    <br />
                            </Tab>
                        </Tabs>

                    </div>
                    </div>

                    <WindowAlert
                        show={this.state.isInfoUpdated}
                        messageType={this.state.messageType}
                        text={this.state.message}
                        onCofirm={this.handleAlert}
                    />
                </div>
                )
            }
    verify_handler_mas = () => {

        const bill_npi = localStorage.getItem('bill_npi');
        axios.post(kinetik_api_url + "/mas_info", {npi: bill_npi, username: this.state.mas_username, password: this.state.mas_password }).then((response) => {
                    toastr.warning("Initiating connection. Check back in 48 hours")
                }).catch((err) => {
                    console.log("mas connection info err", err)
                })
        
            }
    verify_handler_emedny = () => {

        const bill_npi = localStorage.getItem('bill_npi');
        axios.post(kinetik_api_url + "/emedny_info", {npi: bill_npi, username: this.state.emedny_username, password: this.state.emedny_password }).then((response) => {
                    toastr.warning("Initiating connection. Check back in 48 hours")
                }).catch((err) => {
                    console.log("emedny connection info err", err)
                })
            }
    onChange_api_fields_handler = (e) => {
                    this.setState({
                        [e.target.name]: e.target.value
                    });
                }
            }
            
const mapStateToProps = state => ({
                    payersList: state.settingsData.company_payers,
                brokerList: state.settingsData.company_brokers,
                dispatch_info: state.settingsData.dispatch_info,
                user_id: state.settingsData.user_id,
                userData: state.userData,
            });
            
export default connect(mapStateToProps, {companyProfileSettings})(SettingPage);


// WEBPACK FOOTER //
// ./src/app/profile_settings/settingsPage.js